import { Component } from '@angular/core';
import packageJson from "../../../../../../package.json";
import { AuthService } from '@core/auth/auth.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {

  errorText: string|null = null;

  footerTextLeft = ' Think Next, Trust Now '
  today = new Date().getFullYear()
  footerTextRight = ' © ' + this.today + ' InfoCert S.p.a - P.IVA 07945211006'
  footerTextVersion = 'Version '+ packageJson.version
  leftTextShow = false;
  leftText = ``;


  constructor(
    private readonly authService: AuthService,
    private readonly translateService: TranslateService,
  ){
    this.authService.getErrorText.subscribe(value => this.errorText = value);
    this.translateService.get('LOGIN.LEFT-TEXT-SHOW').subscribe(value => this.leftTextShow = (value === 'true'));
    this.translateService.get('LOGIN.LEFT-TEXT').subscribe(value => this.leftText = value);
  }

  clickLogin() {
    this.authService.loginStart();
  }
}